import { useCopilotAction } from '@copilotkit/react-core'

import { F0ModuleCard } from '@factorialco/f0-react'

/**
 * Renders a module card (module icon, title, description, redirect CTA).
 */
export const useModuleCardAction = () => {
  useCopilotAction({
    name: 'AiWidgets.UpsellKit.F0ModuleCard',
    description:
      "Display a module card with module icon, title, description, and an action button (e.g. 'Learn more') to redirect the user.",
    parameters: [
      {
        name: 'moduleName',
        type: 'string',
        description:
          'Module name for the icon (e.g. company_projects, benefits, projects, calendar, reports)',
        required: true,
      },
      {
        name: 'imageSrc',
        type: 'string',
        description: 'Optional image source for the avatar',
        required: false,
      },
      {
        name: 'description',
        type: 'string',
        description: 'Description text below the title',
        required: true,
      },
      {
        name: 'actionHref',
        type: 'string',
        description: 'Optional URL for the action button (redirect)',
        required: false,
      },
    ],
    available: 'frontend',
    followUp: false,
    render: ({ args: { moduleName, imageSrc, description, actionHref } }) => {
      if (!moduleName || !description) return <></>
      return (
        <F0ModuleCard
          imageSrc={imageSrc}
          moduleName={moduleName}
          description={description}
          actionHref={actionHref}
          onAction={actionHref ? undefined : () => {}}
        />
      )
    },
  })
}
